import { useMutation, useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const useResolveUserId = (onResolved: (userId: string) => void) => {
  const userDataService = useServices().manageUserDataService;
  return useMutation({
    mutationFn: async (input: string) => {
      const trimmed = input.trim();
      if (UUID_REGEX.test(trimmed)) return trimmed;
      return userDataService.getUserIdByEmail(trimmed);
    },
    onSuccess: onResolved,
  });
};

export const useGetUserAdminDetails = (userId: string | null) => {
  const userDataService = useServices().manageUserDataService;
  return useQuery({
    queryKey: ['adminUserDetails', userId],
    queryFn: () => userDataService.getUserAdminDetails(userId!),
    enabled: !!userId,
    refetchOnWindowFocus: false,
  });
};
